import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

interface MobileAppBarProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  rightAction?: React.ReactNode;
}

const MOBILE_APP_BAR_STYLES = `
  .mobile-app-bar {
    position: sticky;
    top: 0;
    z-index: 120;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: calc(56px + env(safe-area-inset-top));
    padding: calc(env(safe-area-inset-top) + 10px) 16px 10px;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(231, 237, 244, 0.9);
  }

  .mobile-app-bar__side {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
  }

  .mobile-app-bar__side--right {
    justify-content: flex-end;
  }

  .mobile-app-bar__title {
    flex: 1;
    min-width: 0;
    text-align: center;
    color: #061529;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }
`;

const MobileAppBar: React.FC<MobileAppBarProps> = ({
  title,
  showBack = false,
  onBack,
  rightAction,
}) => (
  <>
    <style>{MOBILE_APP_BAR_STYLES}</style>
    <div className="mobile-app-bar">
      <div className="mobile-app-bar__side">
        {showBack ? (
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
            onClick={onBack}
            style={{ width: 40, height: 40, borderRadius: 12, color: '#061529' }}
          />
        ) : null}
      </div>
      <div className="mobile-app-bar__title">{title}</div>
      <div className="mobile-app-bar__side mobile-app-bar__side--right">
        {rightAction}
      </div>
    </div>
  </>
);

export default MobileAppBar;
